// EID-86: opt-in gate for the `$inputs.$event` transform input.
//
// A transform participates in the live map interaction event simply by
// referencing the reserved `$event` token in its code. The injection in
// Transform.query() is unconditional and harmless, but the data layer uses this
// predicate to gate the click→re-query invalidation so specs without an
// event-using transform pay nothing (map clicks are frequent, and the map
// itself consumes the data registry).
//
// `$event` is the only name the event is exposed under, so a literal token match
// reliably detects usage. The `\b` avoids matching look-alike identifiers such
// as `$eventful`. Worst case (a `$event` token in a comment/string that isn't
// actually used) is a harmless extra re-query for that one transform.
//
// Kept import-free so it can be unit-tested without pulling in the `schemas`
// barrel that `transform.ts` imports.
export const usesEventInput = (code: string | undefined | null): boolean =>
  /\$event\b/.test(code || '');
